import React from 'react';
import styled from 'styled-components'
import { Typo } from '../../ui';
import coursioLogotype from '../../ui/assets/coursio-creen.png';

// Loading spinner container
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${props => props.$fullContainer ? '100vh' : 'auto'};
  width: 100%;
  font-size: 1.2rem;
  color: ${props => props.theme.colors.PRIMARY};
  gap: 20px;
`

const CoursioLogo = styled.img`
  max-width: 285px;
  height: auto;
`

// Spinner animation
const LoadingSpinner = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: ${props => props.$themeColor || props.theme.colors.PRIMARY};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  
  div:nth-child(1) {
    left: 8px;
    animation: spinner1 0.6s infinite;
  }
  
  div:nth-child(2) {
    left: 8px;
    animation: spinner2 0.6s infinite;
  }
  
  div:nth-child(3) {
    left: 32px;
    animation: spinner2 0.6s infinite;
  }
  
  div:nth-child(4) {
    left: 56px;
    animation: spinner3 0.6s infinite;
  }
  
  @keyframes spinner1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  
  @keyframes spinner3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  
  @keyframes spinner2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
`

const LoadingDots = ({showLogo, message, themeColor, fullContainer}) => {

  return (
    <LoadingContainer $fullContainer={fullContainer}>
      {showLogo && <CoursioLogo src={coursioLogotype} alt="Coursio Logo" />}
      {message && <Typo.Info>{message}</Typo.Info>}
      <LoadingSpinner $themeColor={themeColor}>
          <div></div><div></div><div></div><div></div>
      </LoadingSpinner>
    </LoadingContainer>
  );
};

export default LoadingDots;
